// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const MultichannelSequencesPage = lazy(() => import('./pages/MultichannelSequencesPage'));
const CadenceBuilderPage = lazy(() => import('./pages/CadenceBuilderPage'));
const EngagementTrackingPage = lazy(() => import('./pages/EngagementTrackingPage'));
const CallRecordingPage = lazy(() => import('./pages/CallRecordingPage'));
const EmailTrackingPage = lazy(() => import('./pages/EmailTrackingPage'));
const AbTestingPage = lazy(() => import('./pages/AbTestingPage'));

export const SequencesRoutes: RouteObject = {
  path: 'sequences',
  element: <ModuleGuard moduleId="sales.sequences" />,
  children: [
    { path: 'multichannel-sequences', element: <MultichannelSequencesPage />, handle: { crumb: 'Multichannel Sequences' } },
    { path: 'cadence-builder', element: <CadenceBuilderPage />, handle: { crumb: 'Cadence Builder' } },
    { path: 'engagement-tracking', element: <EngagementTrackingPage />, handle: { crumb: 'Engagement Tracking' } },
    { path: 'call-recording', element: <CallRecordingPage />, handle: { crumb: 'Call Recording' } },
    { path: 'email-tracking', element: <EmailTrackingPage />, handle: { crumb: 'Email Tracking' } },
    { path: 'ab-testing', element: <AbTestingPage />, handle: { crumb: 'A/B Testing' } },
  ],
};
